'use strict';

var SafeLocalStorage = require('../utils/SafeLocalStorage'),
    guid = require('simple-guid');

var Migrations = {
  migrateDraftFromOldEditor() {
    var prefix = 'editor/collections/draft_collection',
        draftId = (SafeLocalStorage.getItem(prefix) || '').split(',')[0];

    if (!draftId) {
      return;
    }

    var stamp = JSON.parse(SafeLocalStorage.getItem(prefix + '-' + draftId));
    delete stamp.id;

    SafeLocalStorage.removeItem(prefix);
    SafeLocalStorage.removeItem(prefix + '-' + draftId);

    SafeLocalStorage.setItem('draft', JSON.stringify(stamp));
  },

  migrateGrabbagFromOldEditor() {
    var prefix = 'editor/collections/grabbox_collection',
        grabboxIds = (SafeLocalStorage.getItem(prefix) || '').split(',');

    if (grabboxIds.length === 1 && grabboxIds[0] === '') {
      return;
    }

    SafeLocalStorage.removeItem(prefix);

    var grabbox = grabboxIds.map(function (imageId) {
      var key = prefix + '-' + imageId,
          image = JSON.parse(SafeLocalStorage.getItem(key));

      SafeLocalStorage.removeItem(key);
      image.media.uuid = guid();

      return {
        uuid: guid(),
        image: image.media
      };
    });

    SafeLocalStorage.setItem('grabbag', JSON.stringify(grabbox));
  }
};


module.exports = Migrations;


/** WEBPACK FOOTER **
 ** ./utils/Migrations.js
 **/